import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { message } from 'antd';
import { isEmail } from '../../utils';
import { popWithResult } from '../../utils/intent-manager';
import API from '../../API';

export default function () {
	const navigate = useNavigate();
	const location = useLocation();

	const [client, setClient] = useState({});
	const [loading, setLoading] = useState(false);
	const disabled = !client.name?.trim() || client.type == undefined || !client.phone?.trim();

	const state = location.state;
	const intent = state !== null;

	const createClient = async () => {
		if (disabled) return;
		if (!client.phone.match(/^(\+[0-9]{2} ?)?([0-9] ?){9}$/)) return message.error('Telefon jest niepoprawny');
		if (client.email && !isEmail(client.email)) return message.error('Email jest niepoprawny');
		// if (client.nip && !isNip(client.nip)) return message.error('NIP jest niepoprawny');
		if (client.bdo?.length > 14) return message.error('BDO jest za długi');
		if (!client.email) delete client.email;
		if (!client.nip) delete client.nip;
		if (!client.bdo) delete client.bdo;
		if (!client.street) delete client.street;
		if (!client.city) delete client.city;
		if (!client.postal) delete client.postal;
		if (!client.description) delete client.description;

		try {
			setLoading(true);

			const c = await API.clients.create(client);

			setLoading(false);
			message.success('Stworzono klienta');
			if (intent) {
				popWithResult(navigate, location.state, c);
			} else {
				navigate(`/panel/clients/${c.id}`, { replace: true });
			}
		} catch (e) {
			setLoading(false);
			message.error(`${e}`);

			console.trace(e);
		}
	};

	return [
		{
			client,
			disabled,
			loading,
			intent,
		},
		{
			nameChanged: (e) => setClient((client) => ({ ...client, name: e.target.value })),
			phoneChanged: (e) => setClient((client) => ({ ...client, phone: e.target.value })),
			typeChanged: (value) => setClient((client) => ({ ...client, type: value.value })),
			emailChanged: (e) => setClient((client) => ({ ...client, email: e.target.value })),
			nipChanged: (e) => setClient((client) => ({ ...client, nip: e.target.value })),
			bdoChanged: (e) => setClient((client) => ({ ...client, bdo: e.target.value })),
			streetChanged: (e) => setClient((client) => ({ ...client, street: e.target.value })),
			cityChanged: (e) => setClient((client) => ({ ...client, city: e.target.value })),
			postalChanged: (e) => setClient((client) => ({ ...client, postal: e.target.value })),
			descriptionChanged: (e) => setClient((client) => ({ ...client, description: e.target.value })),
			createClient,
		},
	];
}
